
import  axiosInstance  from "./config/axiosConfigs";
import { getToken } from "../cookie/authCookie";

export const ResourceAPI = {

  postGameResource: async function (gameResourceDTO) {
  
    const response = await axiosInstance.request({
      url: `/resource/config`,
      method: "POST",
      timeout: 20000,
      data: gameResourceDTO,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postUpdateResourceIsOpen: async function (reqData) {
    const response = await axiosInstance.request({
      url: `/resources/update-is-open`,
      method: "POST",
      timeout: 5000,
      data: reqData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getResourcesAndGame: async function (clubId) {
  
    const response = await axiosInstance.request({
      url: `/resources/club/` + clubId,
      method: "GET",
      timeout: 2000,
      
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  patchResource: async function (resourceId, resourceInfo) {
  
    const response = await axiosInstance.request({
      url: `/resource/resourceId/` + resourceId,
      method: "PATCH",
      timeout: 2000,
      data: resourceInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },


};